<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  a {
    display: flex;
    align-items: center;
    text-align: center;
    border: solid 1px transparent;
    border-radius: 6px;
    justify-content: center;

    &.has-link {
      cursor: pointer;
    }

    &.xxs {
      height: utils.in_rem(16px);
      width: utils.in_rem(16px);
    }

    &.xs {
      height: utils.in_rem(20px);
      width: utils.in_rem(20px);
    }

    &.small {
      height: utils.in_rem(24px);
      width: utils.in_rem(24px);
    }

    &.medium {
      height: utils.in_rem(34px);
      width: utils.in_rem(34px);
    }

    &.xl {
      height: utils.in_rem(54px);
      width: utils.in_rem(54px);
    }
  }
</style>

<script>
  import Tooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/Tooltip.svelte";

  export let src;
  export let alt;
  export let href;
  export let size = "medium";

  let cls = "";
  export { cls as class };
</script>

<Tooltip
  placement="bottom"
  let:onmouseenter
  let:onmouseleave
  let:onfocus
  let:onblur
  let:dismiss
>
  <span slot="tooltip"><slot /></span>
  <a
    class="{cls} {size} {href ? 'has-link' : ''}"
    {href}
    target="_blank"
    rel="noopener noreferrer"
    on:mouseenter={onmouseenter}
    on:mouseleave={onmouseleave}
    on:focus={onfocus}
    on:blur={onblur}
    on:click={dismiss}
    {...$$restProps}
  >
    <img {src} {alt} />
  </a>
</Tooltip>
